export const pillars = ['Book Blueprint', 'Character Development', 'Manuscript Writing', 'Storytelling & Dialogue', 'Editing & Revision', 'Final Manuscript'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'THE BOOK BLUEPRINT™',
  pack: 'The Complete Book Planning System',
  desc: 'Turn your raw concept into a professional book roadmap.',
  focusLabel: 'Define your',
  focus: ['Premise', 'Target Reader', 'Theme', 'Conflict', 'Structure', 'Chapters', 'Subplots', 'Emotional Journey'],
  closing: 'Stop guessing what your book should become. Build the blueprint first.'
}, {
  n: 2,
  emoji: '📗',
  title: 'THE CHARACTER & WORLD ENGINE™',
  pack: 'The Character Development System',
  desc: 'Build characters with depth, motivation and consistency.',
  focusLabel: 'Develop',
  focus: ['Psychology', 'Goals', 'Fears', 'Conflict', 'Character Arcs', 'Relationships', 'Backstory', 'Secrets', 'Voice', 'World Rules'],
  closing: 'Give your characters a reason to exist beyond simply moving the story forward.'
}, {
  n: 3,
  emoji: '📕',
  title: 'THE MANUSCRIPT ENGINE™',
  pack: 'The Chapter-Building System',
  desc: 'Turn your outline into actual manuscript pages.',
  focusLabel: 'Develop',
  focus: ['Chapter Openings', 'Scene Objectives', 'Conflict', 'Tension', 'Stakes', 'Emotional Scenes', 'Pacing', 'Transitions', 'Chapter Endings'],
  closing: 'Move from “I have an idea.” to “I know what happens next.”'
}, {
  n: 4,
  emoji: '📓',
  title: 'THE STORYTELLING & DIALOGUE LAB™',
  pack: 'The Writing Enhancement System',
  desc: 'Make your manuscript more engaging, natural and human.',
  focusLabel: 'Improve',
  focus: ['Dialogue', 'Character Voice', 'Subtext', 'Description', 'Show vs. Tell', 'Narrative Voice', 'Rhythm', 'Foreshadowing', 'Emotional Resonance'],
  closing: 'Because a finished manuscript should sound like your story, not generic AI output.'
}, {
  n: 5,
  emoji: '📗',
  title: 'THE AUTHOR’S EDITING ROOM™',
  pack: 'The Revision & Editing System',
  desc: 'Find the problems hiding inside your first draft.',
  focusLabel: 'Identify',
  focus: ['Plot Holes', 'Character Inconsistencies', 'Weak Chapters', 'Pacing Problems', 'Repetition', 'Weak Scenes', 'Dialogue Issues', 'Unresolved Threads'],
  closing: 'Turn your rough draft into a stronger manuscript.'
}, {
  n: 6,
  emoji: '📙',
  title: 'THE FINISHED BOOK SYSTEM™',
  pack: 'The Final Manuscript Blueprint',
  desc: 'Bring the entire book together.',
  focusLabel: 'Review',
  focus: ['Structure', 'Character Arcs', 'Timeline', 'Chapter Flow', 'Opening', 'Ending', 'Story Promise', 'Loose Threads', 'Final Quality Control'],
  closing: 'Your goal isn’t another draft. Your goal is a finished manuscript.'
}];
export const volumeIncludes = ['Step-by-step Copy & Paste Prompts', 'Fill-in-the-blank brackets for fast customization', 'Structured AI instructions', 'Practical author workflows', 'Revision and quality-control guidance'];
export const bonuses = [{
  n: '01',
  title: 'THE WRITER’S BLOCK BREAKER™',
  tagline: '50 AI Prompts to Get Unstuck, Restart Your Writing & Keep Your Story Moving',
  desc: 'Break through stalled scenes, difficult chapters and creative roadblocks with targeted prompts designed to get your writing moving again.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/kXY2oDkcmKp7noizrMGw29/BONO1.webp'
}, {
  n: '02',
  title: 'THE AUTHOR’S QUICK-START VAULT™',
  tagline: '25 AI Prompts to Start Building Your Book in Your First 30 Minutes',
  desc: 'A guided starting system to help you define your idea, establish direction and begin building your book without staring at a blank page.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/8sKMzUyDH7ZaantKwVoNPg/BONO1_(1).webp'
}, {
  n: '03',
  title: 'THE AI AUTHOR’S CHARACTER BIBLE™',
  tagline: 'The Complete Character Development Workbook for AI-Assisted Writers',
  desc: 'Create a reusable character reference system covering psychology, motivations, relationships, backstory, voice, conflicts and character arcs.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/cMycM8uMFrnKawrAk3aN9n/BONO3.webp'
}, {
  n: '04',
  title: 'THE MANUSCRIPT CONSISTENCY CHECKER™',
  tagline: '30 AI Checks to Find Plot Holes, Contradictions & Weak Writing Before You Publish',
  desc: 'Run structured checks across your manuscript to identify inconsistencies, timeline problems, weak logic, repetition and continuity issues.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/93Q9MUWg34sY5kvTMCMif1/BONO1_(3).webp'
}];